import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import {
  EditFacCombosModel,
  FullFacModel,
  EditFacFunnelStagesModel,
  DiscardModel,
  TransferFormModel
} from '../../../../core/models/edit-fac-modal.model';
import { EditFacModalService } from '../service/edit-fac-modal.service';
import { emailRegex } from '../../../../core/constants/consts';
import moment from 'moment';
import { SnackbarService } from '../../snackbar/service/snackbar.service';
import { ButtonsPopupService } from '../../buttons-popup/service/buttons-popup.service';
import { ButtonsPopupModel } from '../../buttons-popup/buttons-popup.model';
import { GeralService } from 'src/app/core/services/geral-service/geral-service';
import { CheckTaskStatusService } from 'src/app/core/services/check-task-status-service/check-task-status-service';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { Phone } from 'src/app/core/models/phone.model';

import { isPhoneValid, removeMask } from 'src/app/core/constants/flag-Input-const';
import {
  contactTypeValidate,
  returnDateValidate,
  visitDateValidate,
  descriptionValidate
} from 'src/app/core/validators/edit-fac-modal.validators';
import { OrderCard } from 'src/app/core/models/facs.model';
import { FacsService } from 'src/app/facs/service/facs.service';
import { Router } from '@angular/router';
import { GoogleTagManagerService } from 'src/app/core/analytics/google-tag-manager.service';
import { CommunicationProxyService } from 'src/app/shared/services/communication-proxy.service';
import { CommunicationSubjectEnum } from 'src/app/shared/enum/communication-subject-enum'

@Component({
  selector: 'app-modal-geral-chat',
  templateUrl: './modal-geral.component.html',
  styleUrls: ['./modal-geral.component.scss']
})

export class ModalGeralChatComponent implements OnInit {

  @Input() orderCard: OrderCard = {
    above_fac_id: null,
    below_fac_id: null
  };
  @Input() facItem: FullFacModel;
  @Input() combosList: EditFacCombosModel;
  @Input() columnType: EditFacFunnelStagesModel;
  @Input() geralForm: FormGroup;
  @Output() displayFilesUploadModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() displaySearchProductModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeM: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeEdition: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() openOfferedProduct: EventEmitter<void> = new EventEmitter<void>();
  @Output() openOriginLead: EventEmitter<void> = new EventEmitter<void>();

  public messageForm: FormGroup;
  public msgStyle;

  public readonly returnInList = ['Minuto', 'Hora', 'Dia', 'Semana'];
  public returnInTitle: string;
  public chatMessages = [];
  public readonly popModal: ButtonsPopupModel = {
    title: 'Atenção',
    description: 'Selecione o tipo de interesse do cliente.',
    buttons: [
      {
        btnType: 1,
        title: 'Com interesse',
        func: () => this.refactor('Com')
      },
      {
        btnType: 1,
        title: 'Sem interesse',
        func: () => this.refactor('Sem')
      }
    ]
  };

  public readonly popupArchive: ButtonsPopupModel = {
    title: 'Arquivar fac',
    description:
    'Você tem certeza que deseja arquivar esta fac? Facs arquivadas podem ser acessadas utilizando o filtro de facs arquivadas.',
    buttons: [
      {
        btnType: 3,
        title: 'Cancelar',
        func: () => { }
      },
      {
        btnType: 1,
        title: 'Arquivar',
        func: () => this.archiveFac(true)
      }
    ]
  };

  public visitDate = {
    date: '',
    hour: null
  };

  public dropdownsState = {
    funnel: false,
    sub_funnel: false,
    temp: false,
    contact: false,
    return_in: false,
    phone: false,
    alternative_phone: false,
    email: false,
    alternative_email: false,
    discard: false
  };

  public formatedBadged = {
    STAND: null,
    REAL_STATE_DEVELOPER_SELLER: null,
    BOUGHT: null
  };

  public addPhone: {phone: string, ddi: string, invalid: boolean} = {
    phone: '',
    ddi: '',
    invalid: false
  };
  public addEmail = {
    value: '',
    invalid: false
  };
  public showAdd = {
    phone: false,
    email: false
  };
  public facHistory;
  public showDiscardPopup = false;
  public showTransferPopup = false;
  public activeTab = 1;
  public isEditing = false;
  public availableMessages: any = [];

  get feature_lead_env() {
    return this.environmentService.getEnvVar('feature_fac_lead_origin') === 'true';
  }

  constructor(
    public snackService: SnackbarService,
    private facModalService: EditFacModalService,
    private snackbarService: SnackbarService,
    private btnService: ButtonsPopupService,
    public geralService: GeralService,
    private checkStatusService: CheckTaskStatusService,
    private translate: TranslateService,
    private environmentService: EnvironmentService,
    private fb: FormBuilder,
    private facService: FacsService,
    private router: Router,
    private googleTagService: GoogleTagManagerService,
    private communicationProxyService: CommunicationProxyService
  ) { }

  public featureProductSheet = this.environmentService.getEnvVar('feature_product_sheet') === 'true';
  public productUrl: string;
  ngOnInit() {
    if (this.featureProductSheet) {
      this.productUrl = this.facItem.origin_product ? '/produtos/ficha/' + this.facItem.origin_product.sku : null;
    } else {
      this.productUrl = this.facItem.origin_product ? this.facItem.origin_product.url : null;
    }

    if (
      this.geralForm.get('column_type').value.value.toLocaleLowerCase() === 'em atendimento'
      && this.facItem.funnel_stage.value.toLocaleLowerCase() !== 'em atendimento') {
      if (this.geralForm.get('column_type').value.sub_items.length === 0) {
        this.btnService.show(this.popModal);
      }
    }

    if (this.geralForm.get('column_type').value.value.toLocaleLowerCase() !== this.facItem.funnel_stage.value.toLocaleLowerCase()) {
      this.isEditing = true;
      this.setFormValidation(true);
      this.forceFormValidation(this.geralForm);
    }

    if (this.facItem.badges) {
      this.facItem.badges.forEach(item => {
        this.formatedBadged[item.name] = {
          description: item.description
        };
      });
    }
    this.getFacHistory();
    this.initMessageForm();
    this.getChatCombo();
    this.getClientChat();
    this.checkActiveTab();
  }


  checkActiveTab() {
    if (this.router.url.includes('chat=true')) {
      this.activeTab = 2;
      this.router.navigate(
        [],
        {
          queryParams: { chat: null },
          queryParamsHandling: 'merge'
        });
    }
  }

  scrollChat() {
    setTimeout(() => {
      const chat = document.getElementById('history-chat');
      const chatHeight = document.getElementById('scroll-height');
      chat.scrollTop = chatHeight.scrollHeight;
    }, 50);
  }

  private refactor(data: string) {
    this.geralForm.get('column_type').patchValue({
      value: 'Em Atendimento',
      sub_items: [`${data} interesse`]
    });
  }

  getChatCombo() {
    this.facModalService.getChatCombos(this.facItem.id).subscribe(resp => {
      this.availableMessages = resp.messages;
    });
  }

  getFacHistory() {
    this.facModalService.getFacHistory(this.facItem.id).subscribe(resp => {
      this.facHistory = resp;
      this.scrollChat();
     },
     err => {
        this.facHistory = err.error;
      });
  }

  forceFormValidation(formGroup: FormGroup) {
    for (const form in formGroup.controls) {
      if (formGroup.controls[form]) {
        formGroup.controls[form].updateValueAndValidity();
      }
    }
  }

  setGeralFormValue(control: string, value: any) {
    this.geralForm.get(control).patchValue(value);
    this.geralForm.get(control).markAsDirty();
  }

  clearFieldsOnChange() {
    if (this.columnType.value === 'Sem Contato') {
      this.geralForm.get('contact_type').patchValue('');
    }

    if (this.columnType.value !== 'Visita') {
      this.geralForm.get('visit_date').reset();
    }

    if (this.columnType.value === 'Visita') {
      this.geralForm.get('return_date').patchValue({});
    }
  }

  changeTemp(item) {
    this.facItem.temperature = Object.assign({}, item);
    this.dropdownsState.temp = false;
    this.combosList.temperatures.forEach(temp => {
      temp.tags.forEach(tag => tag.active = false);
    });

    this.patchFac({temperature: this.facItem.temperature});
  }

  callWhats(phone) {
    this.facModalService.callWhatsApp(phone.ddi + phone.phone);
  }

  copyPhone(phone: Phone) {
    this.snackService.show('Telefone copiado')
    this.geralService.copyToClipboard(phone.phone);
  }

  setPhone(event) {
    this.addPhone =  { ...this.addPhone, ...event};
  }

  addPhoneClick() {
    this.addPhone.invalid = false;
    const formatedPhone = removeMask({
      ddi: this.addPhone.ddi,
      phone: this.addPhone.phone
    });

    if (isPhoneValid(formatedPhone)) {
      this.addPhone.invalid = true;
      return;
    }

    this.facModalService.updateFacPhone(this.facItem.id, formatedPhone).subscribe(resp => {
      this.checkStatusService.checkTaskStatus(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe(() => {
        if (this.facItem.person.phone) {
          this.facItem.person.alternative_phone = formatedPhone;
        } else {
          this.facItem.person.phone = formatedPhone;
        }
        this.snackbarService.show('O telefone foi adicionado', 'success');
        this.showAdd.phone = false;
        this.getFacHistory();
        this.addPhone = {
          phone: '',
          ddi: '',
          invalid: false
        };
      }, (err) => this.sendErrors(err));
    }, (err) => this.sendErrors(err));
  }

  private sendErrors(err) {
    this.addPhone.invalid = true;
  }

  addEmailClick() {
    if (!emailRegex.test(this.addEmail.value)) {
      this.addEmail.invalid = true;
      return;
    }

    this.facModalService.setLoader(true);
    this.facModalService.updateFacEmail(this.facItem.id, this.addEmail.value).subscribe(resp => {
      this.checkStatusService.checkTaskStatus2(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe(() => {
        if (!this.facItem.person.email) {
          this.facItem.person.email = this.addEmail.value;
        } else {
          this.facItem.person.alternative_email = this.addEmail.value;
        }
        this.snackbarService.show('O e-mail foi adicionado', 'success');
        this.getFacHistory();
        this.showAdd.email = false;
        this.addEmail = {
          value: '',
          invalid: false
        };
        this.facModalService.setLoader(false);
      },
      (err) => this.emailErrors(err));
    },
    (err) => this.emailErrors(err));
  }

  private emailErrors(err): void {
    this.translate.get(`${err.error.messages[0].message}`).subscribe((res: string) => {
      this.snackbarService.show(res, 'error');
      this.addEmail.invalid = true;
      this.facModalService.setLoader(false);
    });
  }

  cancelPhoneClick() {
    this.showAdd.phone = false;
    this.addPhone = {
      phone: '',
      ddi: '',
      invalid: false
    };
  }

  cancelEmailClick() {
    this.showAdd.email = false;
    this.addEmail = {
      value: '',
      invalid: false
    };
  }

  formatDate(date: string) {
    const datewithouttimezone = new Date(date);
    const dateWithNoTimezone = new Date(
      datewithouttimezone.getUTCFullYear(),
      datewithouttimezone.getUTCMonth(),
      datewithouttimezone.getUTCDate(),
      datewithouttimezone.getUTCHours(),
      datewithouttimezone.getUTCMinutes(),
      datewithouttimezone.getUTCSeconds()
    );

    return dateWithNoTimezone;
  }

  openFilesUploadModal() {
    this.displayFilesUploadModal.emit(true);
  }

  openSearchProductModal() {
    this.displaySearchProductModal.emit(true);
  }

  initMessageForm() {
    this.messageForm = this.fb.group({
      messageType: [null],
      email: this.facItem.person.email,
      whatsapp: this.getClientWhatsapp(),
      message: [null, Validators.required]
    });
  }

  setMessageType(item) {
    this.messageForm.controls.message.setValue(item.message);
  }

  setFunnel(item) {
    this.geralForm.get('column_type').patchValue({value: item.value, sub_items: []});
    this.geralForm.get('column_type').markAsDirty();

    this.sendGATagOnChangeFunnel(item.value);

    if (item.value === 'Em Atendimento') {
      this.dropdownsState.sub_funnel = true;
    } else {
      this.dropdownsState.funnel = false;
    }

    if (item.value !== this.facItem.funnel_stage.value) {
      this.setFormValidation(true);
    } else {
      this.setFormValidation(false);
    }
    this.activeTab = 1;
    this.isEditing = true;

    this.clearFieldsOnChange();
    this.forceFormValidation(this.geralForm);
  }

  setSubFunnel(sub: string) {
    this.geralForm.get('column_type').patchValue({value: this.geralForm.get('column_type').value.value, sub_items: [sub]});
    this.geralForm.get('column_type').markAsDirty();
    this.dropdownsState.sub_funnel = false;
    this.dropdownsState.funnel = false;

    this.clearFieldsOnChange();
    this.forceFormValidation(this.geralForm);
  }

  getTempIcon(temp: string) {
    switch (temp) {
      case 'Quente':
        return 'hot_temp_ico';
      case 'Morno':
        return 'warm_temp_ico';
      case 'Frio':
        return 'cold_temp_ico';
      default:
        return '';
    }
  }

  clearReturn() {
    this.returnInTitle = '';
    this.geralForm.get('return_date').patchValue({});
  }

  formatReturnIn(value: {name: string, value: string}) {
    if (value.value && value.name) {
      this.returnInTitle = `${value.value} ${value.name}${parseInt(value.value, 10) > 1 ? 's' : ''}`;
    } else {
      this.returnInTitle = null;
    }
    this.geralForm.get('return_date').patchValue(value);
  }

  formatReturnTime() {
    switch (this.geralForm.get('return_date').value.name) {
      case 'Minuto':
        return parseInt(this.geralForm.get('return_date').value.value, 10) * 60000;
      case 'Hora':
        return parseInt(this.geralForm.get('return_date').value.value, 10) * 3600000;
      case 'Dia':
        return parseInt(this.geralForm.get('return_date').value.value, 10) * 86400000;
      case 'Semana':
        return parseInt(this.geralForm.get('return_date').value.value, 10) * 604800000;
    }
  }

  saveNotes() {
    if (this.geralForm.invalid || this.geralForm.pristine) {
      return;
    }

    let notesBody: any = {
      contact_type: '',
      return_date: null,
      visit_date: null,
      description: '',
      attachments: [],
      products: [],
      funnel_stage: {
        value: '',
        sub_items: []
      },
      above_fac_id: this.orderCard.above_fac_id,
      below_fac_id: this.orderCard.below_fac_id
    };

    if (this.geralForm.get('column_type').value.value === 'Visita') {
      if (this.geralForm.get('visit_date').value && this.geralForm.get('visit_date').value.date) {
        notesBody.visit_date = moment(new Date(this.geralForm.get('visit_date').value.date).
        setHours(0, 0, 0, 0)).format(`YYYY-MM-DD[T]${this.geralForm.get('visit_date').value.hour}:00.000`);
        notesBody.visit_date = new Date(notesBody.visit_date).toISOString();
      }
    } else if (this.geralForm.get('return_date').value) {
      notesBody.return_date = this.formatReturnTime();
    }
    if (this.geralForm.get('column_type').value.value !== 'Sem Contato') {
      notesBody.contact_type = this.geralForm.get('contact_type').value;
    }

    notesBody.description = this.geralForm.get('description').value;
    notesBody.products = this.geralForm.get('products').value;
    notesBody.attachments = this.geralForm.get('attachments').value;
    notesBody.funnel_stage = {
      value: this.geralForm.get('column_type').value.value,
      sub_items: this.geralForm.get('column_type').value.sub_items
    };
    this.facModalService.setLoader(true);

    this.facModalService.updateFacNotes(this.facItem.id, notesBody).subscribe(resp => {
      this.checkStatusService.checkTaskStatus2(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe(() => {
        this.snackbarService.show('As alterações foram salvas.', 'success');
        this.resetForm();
        this.facItem.funnel_stage = this.geralForm.get('column_type').value;
        this.facModalService.setClearProductsModal();
        this.facModalService.setLoader(false);
        this.closeM.emit(true);
        this.getFacHistory();
        if (notesBody.products.length > 0) {
          this.facItem.has_offered_products = true;
        }
        this.communicationProxyService.publishMessage(CommunicationSubjectEnum.onFacUpdated, this.facItem.funnel_stage.value);
         }, (err) => {
        this.snackbarService.show(err.error.messages[0].message, 'error');
        this.facModalService.setLoader(false);
      });
    }, err => {
      this.geralForm.get('visit_date').get('hour').reset();
      this.snackbarService.show(err.error.messages[0].message, 'error');
      this.facModalService.setLoader(false);
    });
  }

  patchFac(request: any) {
    this.facModalService.patchFacById(this.facItem.id, request).subscribe((resp) => {
      this.checkStatusService.checkTaskStatus(resp.task_id, this.environmentService.getEnvVar('api_facs')).subscribe(taskId => {
        this.snackbarService.show('As alterações foram salvas.', 'success');
        this.getFacHistory();
      });
    });
  }

  resetForm() {
    this.geralForm.get('contact_type').reset();
    this.geralForm.get('description').reset();
    this.geralForm.get('return_date').patchValue({});
    this.geralForm.get('visit_date').reset();
    this.geralForm.get('attachments').patchValue([]);
    this.geralForm.get('products').patchValue([]);
    this.returnInTitle = '';
    this.geralForm.markAsPristine();
    this.setFormValidation(false);
  }

  setFormValidation(state: boolean) {
    if (state) {
      this.geralForm.controls.contact_type.setValidators([contactTypeValidate()]);
      this.geralForm.controls.return_date.setValidators([returnDateValidate()]);
      this.geralForm.controls.visit_date.setValidators([visitDateValidate()]);
      this.geralForm.controls.description.setValidators([descriptionValidate()]);
    } else {
      this.geralForm.controls.contact_type.setValidators([]);
      this.geralForm.controls.return_date.setValidators([]);
      this.geralForm.controls.visit_date.setValidators([]);
      this.geralForm.controls.description.setValidators([]);
    }
  }

  changeInput(event) {
    const charLimit = 800;

    if (event.keyCode === 86 && event.target.value.length > charLimit) {
      event.target.value = event.target.value.substring(0, charLimit);
      event.preventDefault();
      return false;
    }
    if (event.keyCode === 8 || event.keyCode === 46) {
      return true;
    }
    if (event.target.value.length >= charLimit) {
      event.target.value = event.target.value.substring(0, charLimit);
      event.preventDefault();
      return false;
    }
  }

  makeCall(phone) {
    window.location.href = 'tel:' + phone.ddi + phone.phone;
  }

  sendEmail(email) {
    window.location.href = 'mailto:' + email;
  }

  disableInput(ref) {
    ref.readOnly = true;
    const element: any = document.getElementsByClassName('ant-time-picker-panel-input')[0];
    element.readOnly = true;
  }

  showArchiveAlert(state: boolean) {
    if (state) {
      this.btnService.show(this.popupArchive);
    } else {
      this.archiveFac(false);
    }
  }

  archiveFac(state: boolean) {
    this.facModalService.putFacArchive(this.facItem.id, state).subscribe(resp => {
      this.checkStatusService.checkTaskStatus(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe(taskId => {
        this.snackbarService.show(state ? 'A fac foi arquivada.' : 'A fac foi desarquivada.', 'success');
        this.facItem.archived = state;
        if (state) {
          this.closeEdition.emit(true);
        }
      }, (err) => {
        this.translate.get(`SERVICE_MSGS.${err.error.messages[0].code}`).subscribe((res: string) => {
          this.snackbarService.show(res, 'error');
        });
      });
    });
  }

  discardFac(discardFieds: DiscardModel) {
    this.facModalService.setLoader(true);
    this.facModalService.putFacDiscard(this.facItem.id, discardFieds).subscribe(resp => {
      this.messageResponse(resp.taskId, 'A fac foi descartada.', 'success');
    });
  }

  transferFac(destUser: TransferFormModel) {
    this.facModalService.setLoader(true);
    this.facModalService.postFacTransfer(this.facItem.id, destUser).subscribe(resp => {
      this.messageResponse(resp.taskId, 'A fac foi transferida.', 'success');
    });
  }

  private messageResponse(taskId: string, dataMessage: string, typeMessage: string) {
    this.checkStatusService.checkTaskStatus(taskId, this.environmentService.getEnvVar('api_facs')).subscribe(taskId => {
      this.snackbarService.show(dataMessage, typeMessage);
      this.facModalService.setLoader(false);
      this.closeM.emit(true);
    }, (err) => this.messageErrorsDiscarTransfer(err));
  }

  private messageErrorsDiscarTransfer(err): void {
    this.translate.get(`SERVICE_MSGS.${err.error.messages[0].code}`).subscribe((res: string) => {
      this.snackbarService.show(res, 'error');
      this.facModalService.setLoader(false);
    });
  }

  sendMessageToClient() {
    this.sendClientChat();
    this.isEditing = false;
    this.clearChatForm();
  }

  sendClientChat() {
    const message = {
      person_contact_phone: this.getClientWhatsapp(),
      message: this.replaceNewLine(this.messageForm.value.message),
      contact_types: []
    };

    if (this.messageForm.value.whatsapp) {message.contact_types.push('WHATSAPP'); }

    if (this.messageForm.value.email) {message.contact_types.push('EMAIL'); }

    this.facService.sendClientMessage(this.facItem.id, message).subscribe(resp => {
      if (resp.taskId) {
        this.checkStatusService.checkTaskStatus2(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe (task => {
          if (task.status.id === 1) {
            this.getClientChat();
            this.getFacHistory();
            this.snackbarService.show('A mensagem foi enviada ao cliente.');
            if (resp.whatsapp_link) {
              window.open(resp.whatsapp_link, '_blank');
            }
          }
        });
      }
    });
  }

  getClientWhatsapp(): string {
    const el = this.facItem.person.contacts.find(element => {
      if (element.type === 'WHATSAPP') {
        return element;
      }
    });
    return el ? el.value : '';
  }

  getClientChat() {
    this.facService.getClientMessages(this.facItem.id).subscribe(response => {
      this.chatMessages = response;
    });
  }

  clearChatForm() {
    this.messageForm.controls.message.reset();
    this.messageForm.markAsUntouched();
  }

  replaceNewLine(text: string) {
    return text.replace(/(\r\n|\n|\r)/gm, '<br>');
  }

  resendEmail(messageId) {
    this.facModalService.resendChatEmail(this.facItem.id, messageId).subscribe(resp => {
      if (resp.status.id === 0) {
        this.snackbarService.show('Email será reenviado');
        this.checkStatusService.checkTaskStatus2(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe(task => {
          if (task.status.name === 'Successful') {
            this.getClientChat();
          }
        });
      }
    },
    () => {this.snackbarService.show('Ocorreu um erro ao tentar reenviar o email', 'error', 10); });
  }

  private sendGATagOnChangeFunnel(status) {
    this.googleTagService.pushTag({
      event: 'event',
      eventCategory: 'gestao_fac',
      eventAction: 'clique:status:fac',
      eventLabel: `status: ${status}`,
      dimension8: this.facItem.fac_number
    });
  }
}
